// extracted by mini-css-extract-plugin
export var questionBox = "_ag-0";